export default __webpack_public_path__ + "1ba785d04eced1eead3f125996108d71.svg";